/**
 * @todo: These interfaces are mocked for now but will be replaced with real implementations from APIv2
 * in this ticket https://linear.app/readme-io/issue/RM-13469/hook-up-superhubstorelinter-store-slice-to-the-api
 */
export interface LinterRuleResult {
  rule: string;
  violation: {
    message: string;
    start: number;
    end: number;
  };
}

export interface LinterStyleguideResult {
  description: string;
  score: number;
  title: string;
}

export interface LinterResultsData {
  data: {
    errors: LinterRuleResult[];
    warnings: LinterRuleResult[];
    styleguide: {
      results: LinterStyleguideResult[];
      totalScore: number;
    };
  };
}

export function mockLinterResults(): LinterResultsData {
  return {
    data: {
      errors: [
        {
          rule: "Capitalize 'ReadMe' correctly",
          violation: {
            message: "'readme' should be 'ReadMe'",
            start: 123,
            end: 129,
          },
        },
        {
          rule: "Capitalize 'ReadMe' correctly",
          violation: {
            message: "'readMe UI' should be 'ReadMe UI'",
            start: 150,
            end: 159,
          },
        },
        {
          rule: "Capitalize 'ReadMe' correctly",
          violation: {
            message: "'Readme' should be 'ReadMe'",
            start: 300,
            end: 306,
          },
        },
      ],
      warnings: [
        {
          rule: 'Avoid using bad words',
          violation: {
            message: "'fart' should be 'flatulence'",
            start: 0,
            end: 4,
          },
        },
        {
          rule: 'Remove TODOs from document',
          violation: {
            message: 'TODO comment found in the document',
            start: 500,
            end: 504,
          },
        },
      ],
      styleguide: {
        results: [
          {
            title: 'Structure',
            score: 8,
            description:
              "The Markdown generally adheres to the prescribed structure for larger features, including sections like 'Overview' (implied in the intro), 'Use Cases' (covered by 'What's New'), and 'Technical Info / Edge-cases/FAQ' (in 'Before You Migrate' and 'Feature Compatibility'). However, it lacks explicit 'Overview' and 'What's Next' headings, which could improve clarity.",
          },
          {
            title: 'Dividers',
            score: 10,
            description:
              'Dividers (***) are consistently used between major sections and use cases, which aligns perfectly with the style guide.',
          },
          {
            title: 'AP Style',
            score: 7,
            description:
              "While generally well-written, some minor deviations from strict AP style exist. For instance, the use of em dashes without spaces around them, and the capitalization of 'Enterprise' when it's not part of a proper noun, could be refined.",
          },
          {
            title: 'Screenshots',
            score: 10,
            description:
              'Screenshots are used sparingly and effectively, only when necessary to illustrate a point (e.g., the migration banners), which adheres to the guideline of not overusing them.',
          },
        ],
        totalScore: 8.75,
      },
    },
  };
}
